import { render, staticRenderFns } from "./RecentSessionsWidget.vue?vue&type=template&id=52c05fee&scoped=true"
import script from "./RecentSessionsWidget.vue?vue&type=script&lang=js"
export * from "./RecentSessionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c05fee",
  null
  
)

export default component.exports